import React, { Component } from 'react';
import format from 'string-format';

import Slider from '../../../../../Shared/React/js/components/sliders/RangeSlider';

// TODO: Extract common SpendSlider in shared

export default class SpendSlider extends Component {
    constructor(props) {
        super(props);

        this.lowestValue = props.values[0].key;
        this.biggestValue = props.values[props.values.length - 1].key;

        this.state = {
            initialRange: [props.minValue, props.maxValue],
            rawMinValue: null,
            rawMaxValue: null
        };

        this.handleSliderValueChanged = this.handleSliderValueChanged.bind(this);
        this.handleSliderValueUpdating = this.handleSliderValueUpdating.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        return props.minValue !== state.initialRange[0] || props.maxValue !== state.initialRange[1]
            ? {
                  initialRange: [props.minValue, props.maxValue],
                  rawMinValue: null,
                  rawMaxValue: null
              }
            : null;
    }

    handleSliderValueChanged(minValue, maxValue) {
        this.props.actions.changeSpend(minValue, maxValue);
    }

    handleSliderValueUpdating(minValue, maxValue) {
        this.setState({
            rawMinValue: minValue,
            rawMaxValue: maxValue
        });
    }

    getLabel(min, max) {
        min = min && min !== this.lowestValue ? min : this.lowestValue;

        max = max && max !== this.biggestValue ? max : this.biggestValue;

        const minValue = this.props.values.find(v => v.key === min).value;
        const maxValue = this.props.values.find(v => v.key === max).value;

        if (
            (max === this.biggestValue && min === this.lowestValue) ||
            max === this.lowestValue ||
            min === this.biggestValue
        ) {
            return <strong>{this.props.anyPriceLabel}</strong>;
        } else if (max === this.biggestValue) {
            return (
                <span
                    dangerouslySetInnerHTML={{
                        __html: format(this.props.fromLabel, `<strong>${minValue}</strong>`)
                    }}
                />
            );
        } else if (min === this.lowestValue) {
            return (
                <span
                    dangerouslySetInnerHTML={{
                        __html: format(this.props.uptoLabel, `<strong>${maxValue}</strong>`)
                    }}
                />
            );
        } else if (min === max) {
            return (
                <span
                    dangerouslySetInnerHTML={{
                        __html: format(this.props.exactlyLabel, `<strong>${minValue}</strong>`)
                    }}
                />
            );
        }

        return (
            <span
                dangerouslySetInnerHTML={{
                    __html: format(this.props.toLabel, `<strong>${minValue}</strong>`, `<strong>${maxValue}</strong>`)
                }}
            />
        );
    }

    render() {
        const minValue = this.state.rawMinValue !== null ? this.state.rawMinValue : this.props.minValue;

        const maxValue = this.state.rawMaxValue !== null ? this.state.rawMaxValue : this.props.maxValue;

        return (
            <React.Fragment>
                <div className="font-7 font-8-lg font-6-sm mar-b-2">{this.getLabel(minValue, maxValue)}</div>
                <div className="slider-container pad-x-3 pad-x-2-sm">
                    <Slider
                        data={this.props.values.map(a => a.key)}
                        minValue={minValue}
                        maxValue={maxValue}
                        onValueChanged={this.handleSliderValueChanged}
                        onValueUpdating={this.handleSliderValueUpdating}
                    />
                </div>
            </React.Fragment>
        );
    }
}
